import Datatable from './Datatable';
export default Datatable;
